import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import DoorPrizes from "@/pages/DoorPrizes";

export const Route = createFileRoute("/raleigh-show-drawing")({
  head: () => pageHead({
    title: 'Raleigh Show Drawing',
    description: 'Enter the Rex & Sons RVs Raleigh show drawing for your chance to win prizes — visit our booth and register today.',
    path: '/raleigh-show-drawing',
  }),
  component: DoorPrizes,
});
